import HighlightTag from './HighlightTag'

export default HighlightTag
